import React, { useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import ATLTinkerpreneurFlipCards from "./ATLTinkerpreneurFlipCards";

/* ── Accordion-style styled components (used for year 2025 and older) ── */

const StyledList = styled.ul`
  list-style-type: unset;
`;

const StyledContentContainer = styled.div`
  position: relative;
  color: white;
  z-index: 2;
  transition: color 0.3s ease;
`;

const StyledTitle = styled.h3`
  position: relative;

  &:hover {
    color: #54bfcc !important;
  }

  &:hover::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: -1;
  }
`;

const VertItem = styled.div`
  position: relative;
  background-image: url(${(props) => props.background});
  background-size: cover;
  background-position: center;
  width: ${(props) => (props.active ? "50%" : "33.33333%")};
  transition: height 0.3s ease, width 0.3s ease;

  aspect-ratio: 1 / 1;

  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1;
    opacity: ${(props) => (props.active ? "1" : "0")};
    transition: opacity 0.3s ease;
  }

  @media (min-width: 992px) {
    aspect-ratio: unset;
    width: ${(props) => (props.active ? "50%" : "33.33333%")};
    height: 500px;
  }
  @media (max-width: 992px) {
    width: 100%;
    height: ${(props) => (props.active ? "auto" : "50%")};
  }
`;

const ATLTinckerpreneurTarget = ({ year }) => {
  const { t } = useTranslation();
  const [activeIndex, setActiveIndex] = useState(-1);

  const ns = year === 2026 ? "atl_tinkerpreneur_2026" : "atl_tinkerpreneur";

  const handleClick = (index) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? -1 : index));
  };

  const isActive = (index) => index === activeIndex;

  const backgrounds = [
    "images/Image_20240401_102143.jpeg",
    "images/how-to-participate.jpeg",
    "images/Image_20240401_110202_355.JPG",
  ];

  if (year === 2026) {
    return <ATLTinkerpreneurFlipCards />;
  }

  return (
    <div className="d-md-block">
      <div className="d-flex flex-column flex-lg-row ">
        {[0, 1, 2].map((index) => (
          <VertItem
            key={index}
            background={backgrounds[index]}
            active={isActive(index)}
            onClick={() => handleClick(index)}
            className="p-4 c-pointer"
          >
            {index === 0 && (
              <StyledContentContainer
                className={`h-100 w-100 d-flex align-items-center justify-content-center ${
                  activeIndex === 0 ? "flex-column" : "flex-row"
                }`}
              >
                <StyledTitle className="text-white">
                  {t(`${ns}.section_1_title`)}
                </StyledTitle>
                {isActive(index) && (
                  <div className="text-box">
                    {year === 2026 ? (
                      <StyledList>
                        <div>{t(`${ns}.section_1_content_1`)}</div>
                        <div style={{ marginTop: "8px" }}>
                          {t(`${ns}.section_1_content_2`)}
                        </div>
                        <StyledList>
                          <li>{t(`${ns}.section_1_content_3`)}</li>
                          <li>{t(`${ns}.section_1_content_4`)}</li>
                          <li>{t(`${ns}.section_1_content_5`)}</li>
                        </StyledList>
                        <div style={{ marginTop: "8px" }}>
                          {t(`${ns}.section_1_content_6`)}
                        </div>
                      </StyledList>
                    ) : (
                      <StyledList>
                        <div>{t(`${ns}.section_1_content_1`)}</div>
                        <StyledList>
                          <li>{t(`${ns}.section_1_content_2`)}</li>
                          <li>{t(`${ns}.section_1_content_3`)}</li>
                          <li>{t(`${ns}.section_1_content_4`)}</li>
                          <li>{t(`${ns}.section_1_content_5`)}</li>
                          <li>{t(`${ns}.section_1_content_6`)}</li>
                          <li>{t(`${ns}.section_1_content_7`)}</li>
                        </StyledList>
                      </StyledList>
                    )}
                  </div>
                )}
              </StyledContentContainer>
            )}
            {index === 1 && (
              <StyledContentContainer
                className={`h-100 w-100 d-flex align-items-center justify-content-center ${
                  activeIndex === 1 ? "flex-column" : "flex-row"
                }`}
              >
                <StyledTitle className="text-white">
                  {t(`${ns}.section_2_title`)}
                </StyledTitle>
                {isActive(index) && (
                  <div className="text-box">
                    <StyledList>
                      <li>
                        {year === 2026 ? (
                          <span>
                            {t(`${ns}.section_2_content_1`)}{" "}
                            <a
                              href="https://aistudent.community/login"
                              target="_blank"
                              rel="noreferrer"
                              style={{ color: "#54bfcc" }}
                            >
                              (aistudent.community/login)
                            </a>
                          </span>
                        ) : (
                          t(`${ns}.section_2_content_1`)
                        )}
                      </li>
                      <li>{t(`${ns}.section_2_content_2`)}</li>
                      <li>
                        {t(`${ns}.section_2_content_3`)}
                        {year === 2026 && (
                          <StyledList style={{ marginTop: "4px" }}>
                            <li>{t(`${ns}.section_2_content_3_sub`)}</li>
                          </StyledList>
                        )}
                      </li>
                      <li>{t(`${ns}.section_2_content_4`)}</li>
                      {year === 2026 && (
                        <li>{t(`${ns}.section_2_content_5`)}</li>
                      )}
                      {year === 2026 && (
                        <li>{t(`${ns}.section_2_content_6`)}</li>
                      )}
                      {year === 2026 && (
                        <li>{t(`${ns}.section_2_content_7`)}</li>
                      )}
                      {year === 2026 && (
                        <li>{t(`${ns}.section_2_content_8`)}</li>
                      )}
                    </StyledList>
                  </div>
                )}
              </StyledContentContainer>
            )}
            {index === 2 && (
              <StyledContentContainer
                className={`text-white h-100 w-100 d-flex align-items-center justify-content-center ${
                  activeIndex === 2 ? "flex-column" : "flex-row"
                }`}
              >
                <StyledTitle className="text-white">
                  {t(`${ns}.section_3_title`)}
                </StyledTitle>
                {isActive(index) && (
                  <StyledList>
                    <li>{t(`${ns}.section_3_content_1`)}</li>
                    <li>{t(`${ns}.section_3_content_2`)}</li>
                    <li>{t(`${ns}.section_3_content_3`)}</li>
                    <li>{t(`${ns}.section_3_content_4`)}</li>
                    <li>{t(`${ns}.section_3_content_5`)}</li>
                    {ns !== "atl_tinkerpreneur_2026" && (
                      <li>{t(`${ns}.section_3_content_6`)}</li>
                    )}
                  </StyledList>
                )}
              </StyledContentContainer>
            )}
          </VertItem>
        ))}
      </div>
    </div>
  );
};

export default ATLTinckerpreneurTarget;
